import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createNote, getStandardNotes, createOrDeleteStandardNote } from '../../../actions/notes'

// import components
import Modal from '../../components/Modal'

import Textarea from '../../elements/textarea'
import Text from '../../elements/text'
import Check from '../../elements/check'
import Inline from '../../elements/inline'
import LabelWrapper from '../../elements/labelWrapper'
import Divider from '../../elements/divider'
import AddButton from '../../elements/addButton'
import RemoveButton from '../../elements/removeButton'
import Icon from '../../elements/icon'
import { DepartmentType } from '../../../constants'

import { ModalIcons, ElementIcons } from '../../elements/icons'

// Utils
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission, hasAccess } from '../../../utils/auth'

// import styles
import './notesmodal.scss'

class NotesModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      show: false,
      showEdit: false,
      note: props.note,
      standardNotes: [],
      isLoading: false,
      error: ''
    }
    this.manipulateNote = this.manipulateNote.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.addStandardNote = this.addStandardNote.bind(this)
    this.addNoteText = this.addNoteText.bind(this)
    this.deleteNoteText = this.deleteNoteText.bind(this)
    this.checkAndUpdateStandardNotes = this.checkAndUpdateStandardNotes.bind(this)
    this.updateStandardNote = this.updateStandardNote.bind(this)
    // this.renderStandardNotes = this.renderStandardNotes.bind(this)
  }

  componentDidMount () {
    if (this.checkAndUpdateStandardNotes(this.props.standardNotes) === false) {
      // Get standardNotes if not from props
      this.props.getStandardNotes().then((res) => {
        this.setState({
          standardNotes: res.data
        })
      })
    }
  }

  componentWillReceiveProps (props) {
    if (props.show !== this.state.show) {
      this.setState({
        show: props.show,
        note: props.note,
        isLoading: false,
        error: ''
      })
    }

    this.checkAndUpdateStandardNotes(props.standardNotes)
  }

  checkAndUpdateStandardNotes (standardNotes) {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null

    if (Array.isArray(standardNotes)) {
      this.setState({
        standardNotes: standardNotes
      })

      return true // Did update
    }

    return false // Didn't update
  }

  manipulateNote (e) {
    e.preventDefault()
    this.setState({ isLoading: true, error: '' })

    setTimeout(() => {
      if (this.validateInputs()) {
        let orderID = this.state.note.OrderID
        let NoteTypeID = this.state.note.NoteTypeID
        let SourceID = (typeof this.state.note.SourceID !== 'undefined') ? this.state.note.SourceID : 2
        let CustomInspectionId = (typeof this.state.note.CustomInspectionId !== 'undefined') ? this.state.note.CustomInspectionId : 0
        if (this.props.note.Note !== '') {
          let newNote = {
            Note: this.state.note.Note,
            NoteTypeID: NoteTypeID,
            OrderID: orderID,
            NoteID: this.state.note.NoteID,
            SourceID: SourceID,
            ApplyToInvoice: this.state.note.ApplyToInvoice,
            ShowToCustomer: this.state.note.ShowToCustomer,
            ShowToPaintShop: this.state.note.ShowToPaintShop,
            CustomInspectionId: CustomInspectionId
          }

          // Edit note
          this.props.createNote(newNote).then((res) => {
            this.props.onSuccess(res.data)
            this.props.onClose(false)
            // Toastr
            // window.toastr.success(translation('1931'), translation('13424'))
          }, (err) => {
            if (err) {
              this.setState({
                isLoading: false
              })
              // Toastr
              window.toastr.error(translation('960'), translation('216'))
            }
          })
        } else {
          if (this.props.auth.user.CustomerId !== '-1') {
            NoteTypeID = 0
          } else {
            NoteTypeID = this.state.note.NoteTypeID
          }

          // // IF NoteTypeID === 0
          // if (NoteTypeID === 0) {
          //   NoteTypeID = 1
          // }

          let newNote = {
            Note: this.state.note.Note,
            NoteTypeID: NoteTypeID,
            OrderID: orderID,
            SourceID: SourceID,
            ApplyToInvoice: this.state.note.ApplyToInvoice,
            ShowToCustomer: this.state.note.ShowToCustomer,
            ShowToPaintShop: this.state.note.ShowToPaintShop,
            CustomInspectionId: CustomInspectionId
          }

          // Create note
          this.props.createNote(newNote).then((res) => {
            this.props.onSuccess(res.data)
            this.props.onClose(false)
            // Toastr
            // window.toastr.success(translation('1931'), translation('13424'))
          }, (err) => {
            if (err) {
              this.setState({
                isLoading: false
              })
              // Toastr
              window.toastr.error(translation('960'), translation('216'))
            }
          })
        }
      } else {
        this.setState({
          isLoading: false
        })
        window.toastr.error(translation('13430'), translation('216'))
      }
    }, 50)
  }

  validateInputs () {
    if (
      this.state.note.Note === ''
    ) {
      return false
    }
    return true
  }

  onInputChange (e) {
    let isPaintShop = this.props.auth.departmentType === DepartmentType.Paint
    // called at "onClick" for checkbox... for some reason "onChange" doesn't work here
    if (e.target.type === 'checkbox') {
      if (e.target.name === 'ApplyToInvoice' || e.target.name === 'ShowToCustomer' || e.target.name === 'ShowToPaintShop') {
        let extra = {}

        if (e.target.name === 'ShowToCustomer') {
          extra.NoteTypeID = 0
          if (!this.state.note.ShowToCustomer) {
            extra.NoteTypeID = isPaintShop ? 1 : 0
          }
        }

        if (e.target.name === 'ShowToPaintShop') {
          if (this.state.note.ShowToPaintShop) {
            extra.NoteTypeID = 0
          } else {
            extra.NoteTypeID = 1
          }
        }

        this.setState({
          note: {
            ...this.state.note,
            [e.target.name]: !this.state.note[e.target.name],
            ...extra
          }
        })
      } else {
        this.setState({
          note: {
            ...this.state.note,
            NoteTypeID: this.state.note.NoteTypeID === 0 ? 1 : 0
          }
        })
      }
    } else {
      this.setState({
        note: {
          ...this.state.note,
          Note: e.target.value
        }
      })
    }
  }

  addStandardNote (e) {
    e.preventDefault()
    let inputText = document.getElementsByName('standardNote')[0]
    let noteText = document.getElementsByName('standardNote')[0].value
    if (noteText !== '') {
      let newStandardNote = {
        Id: 0,
        Note: noteText,
        IsDeleted: false
      }
      this.updateStandardNote(newStandardNote)
      inputText.value = ''
    }
  }

  addNoteText (text) {
    let noteText = this.state.note.Note
    if (noteText === '') {
      noteText = text
    } else {
      noteText += '\n'
      noteText = noteText.concat(text)
    }
    this.setState({
      note: {
        ...this.state.note,
        Note: noteText
      }
    })
  }

  deleteNoteText (note) {
    note.IsDeleted = true
    this.updateStandardNote(note)
  }

  updateStandardNote (note) {
    this.props.createOrDeleteStandardNote(note).then((res) => {
      this.setState({
        standardNotes: res.data
      })
      if (typeof this.props.onStandardNoteUpdate === 'function') {
        this.props.onStandardNoteUpdate(res.data)
      }
    })
  }

  render () {
    if (typeof this.props.note.Note === 'undefined') return null

    let modalTitle = translation('13356')
    let isBodyShop = this.props.auth.departmentType === DepartmentType.Body
    let isReferred = this.props.order.IsReferredIn || this.props.order.IsReferredOut
    let isReferredBody = isBodyShop && isReferred

    let bottomBarProps = {
      disabled: this.state.isLoading,
      actionLabelText: translation('13358'),
      onActionClick: this.manipulateNote
    }
    if (typeof this.props.note.IsMine !== 'undefined') {
      bottomBarProps = {
        disabled: this.state.isLoading,
        actionLabelText: translation('13357'),
        onActionClick: this.manipulateNote
      }
      modalTitle = translation('13357')
    }

    const renderStandardNotes = () => {
      if (this.state.standardNotes.length <= 0) return null
      var sNotes = [...this.state.standardNotes]
      // var last = sNotes.length - 1
      // let divClass = 'noteText clearfix'
      var renderedNotes = sNotes.map((note, i) => {
        const deleteNoteTextTest = () => {
          this.deleteNoteText(note)
        }
        // if (i === last) {
        //   divClass += ' space'
        // }
        // console.log(i) // this.deleteNoteText.bind(this, note)
        return (
          <div key={i}>
            <Inline fillChildNum={[0]} block>
              <span>{note.Note}</span>
              {this.state.showEdit === true && (
                <RemoveButton size='s' onClick={deleteNoteTextTest} />
              )}
              <AddButton size='s' onClick={this.addNoteText.bind(this, note.Note)} />
            </Inline>
          </div>
        )
        // return (
        //   <div key={i} className={divClass}>
        //     <span>{note.Note}</span>
        //     <div className='standardNoteActions'>
        //       {this.state.showEdit === true && (<div className='remove' onClick={() => this.deleteNoteText(note)}><img src='/images/icons/Delete_16.png' /></div>)}
        //       <div className='add' onClick={() => this.addNoteText(note.Note)}><img src='/images/icons/Plus-White.png' /></div>
        //     </div>
        //   </div>
        // )
      })
      return renderedNotes
    }
    const toggleEdit = () => {
      this.setState({
        showEdit: !this.state.showEdit
      })
    }
    let defaultNoteTitle = translation('15095')
    if (this.state.standardNotes.length <= 0) {
      defaultNoteTitle = translation('15207')
    }

    return (
      <div className='notes__modal'>
        <Modal
          {...this.props}
          header={modalTitle}
          icon={ModalIcons.Note}
          bottomBarProps={bottomBarProps}
        >
          {this.state.error && <div className='alert alert-danger'>{this.state.error}</div>}
          <Textarea name='Note' onChange={this.onInputChange} value={this.state.note.Note} />
          <Divider noLine />
          {hasSubscriptionPermission(this.props.auth, 20) && (
            <LabelWrapper labelText={<Inline fillChildNum={[0]} fullWidth>{defaultNoteTitle} <Icon icon={ElementIcons.Edit} size='t' onClick={toggleEdit.bind(this)} /></Inline>}>
              {renderStandardNotes()}
            </LabelWrapper>
          )}
          {this.state.showEdit === true && (
            <LabelWrapper labelText={translation('15201')}>
              <Inline fillChildNum={[0]} block>
                <Text name='standardNote' />
                <AddButton onClick={this.addStandardNote} />
              </Inline>
            </LabelWrapper>
          )}

          <Divider noLine />
          {hasSubscriptionPermission(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && (
            <Check id='ApplyToInvoice' name='ApplyToInvoice' value='yes' onClick={this.onInputChange} checked={this.state.note.ApplyToInvoice} labelText={translation('1785')} />
          )}
          {hasSubscriptionPermission(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && (
            <Check id='ShowToCustomer' name='ShowToCustomer' value='yes' onClick={this.onInputChange} checked={this.state.note.ShowToCustomer} labelText={translation(isBodyShop ? 17874 : 17857)} />
          )}
          {hasSubscriptionPermission(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && (isBodyShop || hasAccess([6], this.props.auth.user.UserType)) && (
            <Check id='ShowToPaintShop' name='ShowToPaintShop' value='yes' onClick={this.onInputChange} checked={this.state.note.ShowToPaintShop} disabled={isReferredBody && !this.state.note.ShowToCustomer} labelText={translation(isBodyShop ? 17875 : 17858)} />
          )}
        </Modal>
      </div>
    )
  }
}

NotesModal.propTypes = {
  createNote: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { createNote, getStandardNotes, createOrDeleteStandardNote })(NotesModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NotesModal/index.js